import React, {Component} from 'react';
import {BrowserRouter as Router} from "react-router-dom";
import ReactDOM from 'react-dom';
import PagesR from './Pages';
import Menu from "./Menu";
import MailboxIcon from "./common/MailboxIcon";
import BookingApp from "./common/BookingApp";

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
    apiKey: '93400b4cecfaf594a92f1823638b8bb7',
    plugins: [new BugsnagPluginReact()],
    enabledBreadcrumbTypes: ['error', 'log',/* 'navigation', 'request',*/ 'user']
})

window.gClientData = {};

class App extends Component {
    state = {
        page_with_header: false,
        soundChecked: true,
        notificationChecked: true,
        marketingChecked: true,
        displaySideBar: false,
        clientData: {}

    };

    base_path = bm_base_path;

    constructor() {
        super();
        this.handlePageWithHeader = this.handlePageWithHeader.bind(this);
    }


    handlePageWithHeader = (value) => {
        this.setState({
            page_with_header: value
        })
    };

    render() {

        return (
            <Router basename={this.base_path}>
                <div className="h-100">
                    {
                        this.state.page_with_header ? (
                            // <div id="bm_sidebar_menu" />
                            <Menu/>
                        ) : ('')
                    }
                    <div className="all-content h-100">
                        <PagesR handlePageWithHeader={this.handlePageWithHeader}/>
                    </div>
                </div>
            </Router>
        );
    }
}

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
window.init_app = (node_dom) => {
    console.log('Mounting React App into', node_dom);
    ReactDOM.render(
        <ErrorBoundary>
            <App/>
        </ErrorBoundary>
        , node_dom
    )};

window.init_menu = (node_dom, notUseReact = false) => (
    ReactDOM.render(<Menu notUseReact={notUseReact}/>, node_dom)
);
window.init_counter_messages = (node_dom, notUseReact = false) => {

    console.log('Mounting React MailboxIcon into', node_dom);

    ReactDOM.render(<MailboxIcon notUseReact={notUseReact}/>, node_dom)
};

window.init_booking_app = (node_dom, photo_type) => {
    console.log('Mounting React BookingApp into', node_dom);
    ReactDOM.render(
        <ErrorBoundary>
            <BookingApp photo_key={node_dom} photo_type={photo_type}/>
        </ErrorBoundary>,  document.getElementById ( node_dom + '_div'));
};
